// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {
    filterCollection,
    sortCollection
} from '../../../../shared/services/collections';
import {FormattedMessage} from 'react-intl';
import PartRequest from '@deere/cps-it.warranty-model-factory/lib/part-return';
import PartReturnList from '../../../shared/components/part-return-list';
import RefinableListWidget from '../../../../shared/components/refinable-list-widget';
import SearchBox from '../../../../shared/components/search-box';
import SearchByDropdown from '../../state/search-by-dropdown';
import SearchFilters from '../../state/search-filters';
import TabNavigation from '../../../../shared/components/tab-navigation';
import filterOptions from '../../../shared/state/part-return-filter-options';
import {getNavigationTabs} from '../../../shared/services/navigation-tabs';
import {getSearchBoxPlaceholder} from '../../services/helpers';
import sortOptions from '../../../shared/state/part-return-sort-options';

function handleSearch(query) {

    this.actions.onSearch(this.searchByDropdown.selectedOption.key, query);

}

const PartRequestsSearchMain = props => {

    let sortedCollection;

    sortedCollection = [...props.filteredSearchResults];
    sortedCollection = sortCollection(props.searchFilters.sortBy, props.searchFilters.sortDirection, sortedCollection);
    sortedCollection = filterCollection(props.searchFilters.filterBy, filterOptions, sortedCollection);

    return (
        <main>
            <SearchBox
                defaultOption={props.searchByDropdown.selectedOption.key}
                onOptionChange={props.actions.updateSearchBy}
                onQueryChange={props.actions.updateSearchQueryString}
                onSearch={props::handleSearch}
                placeholderText={getSearchBoxPlaceholder(props.searchByDropdown.selectedOption.key)}
                queryString={props.searchQueryString}
                searchBy={props.searchByDropdown.searchBy}
            />
            <TabNavigation tabs={getNavigationTabs(props, true)}/>
            <section className='search-results'>
                <RefinableListWidget
                    onFilterByChange={props.actions.updateListFilterBy}
                    onSortByChange={props.actions.updateListSortBy}
                    onSortDirectionChange={props.actions.updateListSortDirection}
                    searchFilters={props.searchFilters}
                    sortOptions={sortOptions}
                    type={() => {

                        // no operation

                    }}
                />
                {sortedCollection.length > 0 ?
                    <PartReturnList
                        partReturns={sortedCollection}
                    /> :
                        <span className='empty'>
                            <FormattedMessage id='NO_RESULTS_FOUND'/>
                        </span>
                }
            </section>
        </main>
    );

};

PartRequestsSearchMain.displayName = 'PartRequestsSearchMain';
PartRequestsSearchMain.propTypes = {
    actions: PropTypes.object.isRequired,
    filteredSearchResults: PropTypes.arrayOf(PropTypes.instanceOf(PartRequest)).isRequired,
    searchByDropdown: PropTypes.instanceOf(SearchByDropdown).isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    searchQueryString: PropTypes.string.isRequired
};

export default PartRequestsSearchMain;



// WEBPACK FOOTER //
// ./src/part-requests/search/components/part-requests-search-main/part-requests-search-main.js